import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Settings as SettingsIcon, MessageSquare, UserPlus, BookOpen } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import Layout from '../components/Layout';

// Import des composants existants
import Settings from './Settings';
import RCSAgents from './RCSAgents';
import RCSTesters from './RCSTesters';

export default function OnboardingHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'settings';

  const handleTabChange = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <Layout>
      <div className="space-y-6" data-testid="onboarding-hub-page">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
            <BookOpen className="h-7 w-7 text-indigo-600" />
            Configuration & Onboarding
          </h1>
          <p className="text-slate-500 mt-1">
            Paramètres, agents RCS et gestion des testeurs
          </p>
        </div>
      </div>

      {/* Tabs */}
      <Tabs value={defaultTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="grid w-full max-w-lg grid-cols-3 mb-6">
          <TabsTrigger value="settings" className="flex items-center gap-2" data-testid="tab-settings">
            <SettingsIcon className="h-4 w-4" />
            Paramètres
          </TabsTrigger>
          <TabsTrigger value="agents" className="flex items-center gap-2" data-testid="tab-agents">
            <MessageSquare className="h-4 w-4" />
            Agents RCS
          </TabsTrigger>
          <TabsTrigger value="testers" className="flex items-center gap-2" data-testid="tab-testers">
            <UserPlus className="h-4 w-4" />
            Testeurs
          </TabsTrigger>
        </TabsList>

        <TabsContent value="settings" className="mt-0">
          <Settings embedded={true} />
        </TabsContent>

        <TabsContent value="agents" className="mt-0">
          <RCSAgents embedded={true} />
        </TabsContent>

        <TabsContent value="testers" className="mt-0">
          <RCSTesters embedded={true} />
        </TabsContent>
      </Tabs>
    </div>
    </Layout>
  );
}
